import type { Product } from '@/domains/shoppingCart/AddToCart/AddToCart.interfaces';

import { title, titleLonger } from '../translations';

function countProducts(savedProductIds: number[], products: Product[]): number {
  return products
    .filter((product) => savedProductIds.includes(product.id))
    .map((product) => product.quantity)
    .reduce((a, b) => a + b, 0);
}

export const formatTitle = (
  savedProductIds: number[],
  products: Product[],
  titleType?: 'longer' | 'default',
) => {
  const titleTranslation = titleType === 'longer' ? titleLonger : title;

  if (!savedProductIds.length || !products.length) {
    return titleTranslation.format({
      productsNumber: 0,
    });
  }

  return titleTranslation.format({
    productsNumber: countProducts(savedProductIds, products),
  });
};
